import FormTextArea from "./FormTextArea";

const FormCommentsField = ({
    placeholder = "",
    label = "Observações",
    attributeName = "comments",
    rows = 2,
    maxRows = 5,
    maxLength = 500,
    disabled = false,
}) => {
    return (
        <FormTextArea
            name={attributeName}
            label={label}
            rows={rows}
            maxRows={maxRows}
            maxLength={maxLength}
            placeholder={placeholder}
            disabled={disabled}
        />
    );
};

export default FormCommentsField;
